import React, { useState, memo } from 'react';
import { Section } from './Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Es muy difícil? ¿Me va a costar hacerlo?',
    a: 'Para nada. Hay actividades más simples y otras más desafiantes, pero todas están explicadas paso a paso. Empezás por lo que te resulte cómodo y vas subiendo el nivel cuando quieras.'
  }, {
    q: '¿Necesito saber usar mucho la computadora o el celular?',
    a: 'No. Te llega un mail con el kit, lo descargás una sola vez y ya lo tenés. Si preferís, lo imprimís y hacés los ejercicios en papel, como toda la vida.'
  }, {
    q: '¿Lo puedo imprimir todas las veces que quiera?',
    a: 'Sí. Pagás una sola vez y lo imprimís las veces que quieras, para vos o para regalar a algún familiar o amigo.'
  }, {
    q: '¿De verdad sirve para cuidar la memoria?',
    a: 'Sí. Está basado en métodos científicos probados (neuroplasticidad, reserva cognitiva, Sohlberg & Mateer, Paul Dennison) que muestran que ejercitar el cerebro ayuda a mantenerlo ágil con los años.'
  }, {
    q: '¿Lo puedo hacer solo o necesito ayuda?',
    a: 'Lo podés hacer solo, tranquilamente. Las instrucciones son claras y fáciles. Si algún ejercicio te gusta hacerlo acompañado, también es una linda actividad para compartir con la pareja, un hijo o un nieto.'
  }, {
    q: '¿Cómo recibo el kit después de comprar?',
    a: 'Al instante. Apenas hacés la compra te llega un mail con el link para descargar. Lo abrís en la computadora, el celular o la tablet, y lo imprimís cuando quieras.'
  }, {
    q: '¿Y si no me gusta?',
    a: 'Tenés 7 días para probarlo. Si no te convence, mandás un mail y te devolvemos el dinero completo. Así de simple.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-cream-dark" data-id="element-42">
      <div className="text-center mb-12" data-id="element-43">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-44">
          Preguntas frecuentes
        </h2>
        <p className="text-xl text-gray-600" data-id="element-45">
          Todo lo que querés saber antes de comprar.
        </p>
      </div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-46">
        {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-47">
            <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === idx ? null : idx)} data-id="element-48">
              <span className="font-bold text-gray-900 text-lg pr-4" data-id="element-49">
                {faq.q}
              </span>
              <ChevronDown className={`text-sage-600 shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} size={24} data-id="element-50" />
            </button>
            <AnimatePresence data-id="element-51">
              {openIndex === idx && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-52">
                  <div className="px-6 pb-5 text-gray-600 text-lg border-t border-gray-100 pt-4" data-id="element-53">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}